import React, { Component } from 'react';
import API from '../../utils/API';
import SaveBar from './components/SaveBar';

const PRESETS = [
	'Comp Room Ratio (ideally comp 1:40)',
	'Discounted or waived resort/destination fees',
	'Discounted or complimentary wifi and hardline internet',
	'Cumulative Attrition, 20%',
	'Discounted F&B (minimum 10%)',
	'Staff and VIP Upgrades',
	'Discounted or waived parking (self and valet parking)',
	'Resale and Rebooking Clauses',
	'Multi year rebates',
	'Discounted or waived AV and Branding Fees',
	'No Walk Clause',
	'Waive room rental with F&B achievement'
];

class Concessions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: props.request?.concessions?.custom || [],
			draft: '',
			editing: false,
			saving: false
		};
	}

	toggle = (c) => {
		this.setState((s) => ({
			selected: s.selected.includes(c) ? s.selected.filter((x) => x !== c) : [...s.selected, c],
			editing: true
		}));
	};

	addCustom = () => {
		const v = this.state.draft.trim();
		if (!v || this.state.selected.includes(v)) return;
		this.setState((s) => ({
			selected: [...s.selected, v],
			draft: '',
			editing: true
		}));
	};

	remove = (c) => {
		this.setState((s) => ({
			selected: s.selected.filter((x) => x !== c),
			editing: true
		}));
	};

	save = async () => {
		this.setState({ saving: true });
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/proposal-requests/${this.props.requestId}`,
				{ concessions: { custom: this.state.selected } }
			);
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (e) {
			console.error('Error saving concessions:', e);
			this.setState({ saving: false });
		}
	};

	cancel = () => {
		this.setState({
			selected: this.props.request?.concessions?.custom || [],
			draft: '',
			editing: false
		});
	};

	render() {
		const { selected, draft, editing, saving } = this.state;
		const { request } = this.props;

		// Separate: items the planner explicitly submitted vs. items from the preset checklist
		const custom = selected.filter((c) => !PRESETS.includes(c));
		const presetSelected = selected.filter((c) => PRESETS.includes(c));

		return (
			<>
				{/* ── Planner-submitted concessions (top — always visible) ── */}
				<div className="pr-subsection-head">
					<h2 className="pr-subsection-title" style={{ marginTop: 0 }}>Submitted Concessions</h2>
					{custom.length > 0 && (
						<span className="pr-save-bar-meta">{custom.length} item{custom.length !== 1 ? 's' : ''}</span>
					)}
				</div>
				<p className="pr-field-sublabel">Concessions submitted through the request form.</p>

				{custom.length === 0 ? (
					<div className="pr-section-empty" style={{ marginBottom: 28 }}>
						<i className="las la-gift" />
						No custom concessions were submitted with this request.
					</div>
				) : (
					<div style={{ marginBottom: 28 }}>
						{custom.map((c) => (
							<div key={c} className="pr-chip-row">
								<span>{c}</span>
								<button type="button" className="pr-chip-remove" onClick={() => this.remove(c)}>
									<i className="las la-times" />
								</button>
							</div>
						))}
					</div>
				)}

				{/* ── Add more concessions ──────────────────────────── */}
				<h2 className="pr-subsection-title">Add Concessions</h2>
				<p className="pr-field-sublabel">Type a concession or select from common options below.</p>

				<div className="pr-field-group">
					<div style={{ display: 'flex', gap: 12 }}>
						<input
							className="pr-text-input"
							type="text"
							value={draft}
							onChange={(e) => this.setState({ draft: e.target.value })}
							onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.addCustom(); } }}
							placeholder="Type a concession and press Enter…"
						/>
						<button
							type="button"
							className="pr-btn-ghost"
							onClick={this.addCustom}
							disabled={!draft.trim()}
						>
							<i className="las la-plus" />
							Add
						</button>
					</div>
				</div>

				{/* ── Common concession checklist ──────────────────── */}
				<h2 className="pr-subsection-title">Common Concessions</h2>
				<p className="pr-field-sublabel">Check any that should be included in the proposal.</p>

				<div className="pr-check-list" style={{ marginBottom: 28 }}>
					{PRESETS.map((c) => {
						const on = selected.includes(c);
						return (
							<button
								key={c}
								type="button"
								className={`pr-check-row ${on ? 'checked' : ''}`}
								onClick={() => this.toggle(c)}
							>
								<span className="pr-check-box"><i className="las la-check" /></span>
								<span>{c}</span>
							</button>
						);
					})}
				</div>

				<SaveBar
					editing={editing}
					saving={saving}
					onSave={this.save}
					onCancel={this.cancel}
					updatedAt={request?.updatedAt}
				/>
			</>
		);
	}
}

export default Concessions;
